import { useQuery } from 'react-query';
import { fetchRanks } from '@/api/rank';

export function useRanks({ query }: any) {
  return useQuery(['ranks', { ...query }], () => fetchRanks({ ...query }), {
    keepPreviousData: true,
    retry: false,
  });
}
